"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var fscreen_1 = __importDefault(require("fscreen"));
var nosleep_js_1 = __importDefault(require("nosleep.js"));
// @ts-ignore (@type/o9n does not exist yet)
var o9n_1 = require("o9n");
var react_1 = require("react");
var noSleep = new nosleep_js_1.default();
function useFullscreen() {
    var _a = (0, react_1.useState)(!fscreen_1.default.fullscreenEnabled), fullscreen = _a[0], setFullscreen = _a[1];
    var toggleFullscreen = function () { return fullscreen ? fscreen_1.default.exitFullscreen() : fscreen_1.default.requestFullscreen(document.getElementById('root')); };
    var onFullscreenChange = function () {
        setFullscreen(fscreen_1.default.fullscreenElement != null);
        if (fscreen_1.default.fullscreenElement) {
            o9n_1.orientation.lock('landscape')
                .then(function () { return noSleep.enable(); })
                .catch(function () { return console.info('screen orientation cannot be locked on this device'); });
        }
        else {
            noSleep.disable();
        }
    };
    (0, react_1.useEffect)(function () {
        fscreen_1.default.addEventListener('fullscreenchange', onFullscreenChange);
        return function () {
            fscreen_1.default.removeEventListener('fullscreenchange', onFullscreenChange);
        };
    }, []);
    return { fullscreen: fullscreen, toggleFullscreen: toggleFullscreen, setFullscreen: setFullscreen };
}
exports.default = useFullscreen;
//# sourceMappingURL=useFullscreen.js.map